import AuthService from "../api/services/AuthService";

/**
 * Clear local auth tokens without wiping stable device id / other prefs.
 * Keeps `agce.device_id.v1` so TRUSTED device status survives logout.
 */
export function clearLocalAuthTokens() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("userId");
  } catch {
    // ignore
  }
  try {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("userId");
  } catch {
    // ignore
  }
}

function readRefreshToken() {
  try {
    return localStorage.getItem("refresh_token") || sessionStorage.getItem("refresh_token") || "";
  } catch {
    return "";
  }
}

function notifyAuthListeners() {
  try {
    window.dispatchEvent(new Event("agce-auth-changed"));
    window.dispatchEvent(new Event("agce-auth-token-changed"));
  } catch {
    // ignore
  }
}

/**
 * Best-effort server logout, then clear local tokens and notify listeners.
 * Never throws — UI can always navigate away.
 */
export async function logoutCurrentSession() {
  const refresh = readRefreshToken();
  try {
    await AuthService.logoutSession(refresh);
  } catch {
    // Server may already have revoked; still clear client.
  }
  clearLocalAuthTokens();
  notifyAuthListeners();
}
